import {
    createTSlatePlugin,
    type PluginConfig,
    type SlateEditor,
} from '@udecode/plate';

export type BaseFootnoteEntryConfig = PluginConfig<
    'footnote-entry',
    {
        footnoteIndexOffset: number;
        onSelect?: (id: string) => void;
        _preventDelete: boolean;
        onSuggestionAccepted?: (inlineEditor: SlateEditor, keyId: string, suggestionId: string) => void;
        onSuggestionRejected?: (inlineEditor: SlateEditor, keyId: string, suggestionId: string) => void;
    },
    {
        footnoteEntry: {
            select: (id: string) => void;
        }
    },
    {}
>;

export const BaseFootnoteEntryPlugin = createTSlatePlugin<BaseFootnoteEntryConfig>({
    key: 'footnote-entry',
    node: { isElement: true, isInline: false, isVoid: false },
    options: {
        footnoteIndexOffset: 0,
        _preventDelete: false,
        onSelect: undefined,
        onSuggestionAccepted: undefined,
        onSuggestionRejected: undefined,
    }
})
    .extendEditorApi(({
        getOption,
    }) => ({
        footnoteEntry: {
            select: (id: string) => {
                const onSelect = getOption('onSelect');
                onSelect?.(id);
            },
        }
    }))
    .overrideEditor(({
        tf: { apply },
        type,
        getOption,
    }) => {
        return {
            transforms: {
                apply: (op) => {
                    // Footnote entry cannot be removed
                    if (getOption('_preventDelete') && op.type === 'remove_node' && op.node.type === type) {
                        return;
                    }

                    apply(op);
                }
            },
        };
    });
